export enum Bubble {
  top = 1,
  middle = 2,
  bottom = 3,
}

type Props = {
  bubblePosition: Bubble
}

export default function Bubbles({ bubblePosition }: Props): JSX.Element {
  if (bubblePosition === Bubble.top) {
    return (
      <div className="hidden md:block relative z-10">
        <div className="absolute -z-1 -left-12 -top-12 bg-blue rounded-full h-48 w-48" />
        <div className="absolute -z-1 right-48 -top-4 bg-blue rounded-full h-14 w-14" />
        <div className="absolute -z-1 -right-24 top-36 bg-blue rounded-full h-48 w-48" />
        <div className="absolute -z-1 -left-4 top-72 bg-blue rounded-full h-8 w-8" />
      </div>
    )
  }

  if (bubblePosition === Bubble.middle) {
    return (
      <div className="block relative z-10">
        <div className="absolute -z-1 left-0 -bottom-16 bg-blue rounded-full h-14 w-14" />
        <div className="absolute -z-1 -left-40 -bottom-80 bg-blue rounded-full h-48 w-48" />
        <div className="absolute -z-1 right-24 -bottom-80 bg-blue rounded-full h-8 w-8" />
      </div>
    )
  }

  if (bubblePosition === Bubble.bottom) {
    return (
      <div className="hidden md:block relative z-10">
        <div className="absolute -z-1 left-24 bottom-32 bg-blue rounded-full h-8 w-8" />
        <div className="absolute -z-1 right-24 bottom-48 bg-blue rounded-full h-14 w-14" />
      </div>
    )
  }

  return null
}
